module.exports = __webpack_public_path__ + "images/home-dingtalk-work/tower_dingtalk-0ce6c8f3bcce909869ee606cc23c34f1.png";